import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeOpen: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-open, house"><path d="M13.1322 1.97713C12.4791 1.42299 11.5209 1.42299 10.8678 1.97713L3.61779 8.12865C3.22591 8.46115 3 8.94911 3 9.46304V19.2501C3 20.2166 3.7835 21.0001 4.75 21.0001H8.25C9.2165 21.0001 10 20.2166 10 19.2501V15.2592C10 15.1212 10.1119 15.0092 10.25 15.0092H13.75C13.8881 15.0092 14 15.1212 14 15.2592V19.2501C14 20.2166 14.7835 21.0001 15.75 21.0001H19.25C20.2165 21.0001 21 20.2166 21 19.2501V9.46304C21 8.94911 20.7741 8.46115 20.3822 8.12865L13.1322 1.97713Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeOpen;
